import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { AssetsLoaderSiteConfig } from '../types'

const assetsLoaderSiteConfig: SiteConfigFn<AssetsLoaderSiteConfig> = ({ api }) => {
	const componentsCount = api.rendererModel.getSiteMetaData()?.renderHints?.componentsCount
	let isStylableComponentInStructure = false
	if (componentsCount) {
		for (const compType of Object.keys(componentsCount)) {
			if (compType.startsWith('wixui.Stylable')) {
				isStylableComponentInStructure = true
				break
			}
		}
	}

	const builderComponentsData = api.builder.getBuilderComponentsData()
	const hasBuilderComponents = Object.keys(builderComponentsData.components).length > 0

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig: {
			isStylableComponentInStructure,
			hasBuilderComponents,
		},
	}
}

const name = 'assetsLoader'

export const config = { site: assetsLoaderSiteConfig, name }
